// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnyFn = (...args: any[]) => any;
export type Primitive = string | number | boolean | null | undefined;

export const isString = (target: unknown): target is string => typeof target === 'string';
export const isNumber = (target: unknown): target is number => typeof target === 'number';
export const isNull = (target: unknown): target is null => target === null;
export const isNullish = (target: unknown): target is null | undefined =>
  typeof target === 'undefined' || isNull(target);
export const isObject = (target: unknown): target is object => !isNull(target) && typeof target === 'object';
export const isFunction = (target: unknown): target is AnyFn => typeof target === 'function';
export const isPrimitive = (target: unknown): target is Primitive => !isObject(target);
export const isBase58 = (str: string) => /^[A-HJ-NP-Za-km-z1-9]*$/.test(str);
